import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Space } from "antd";
import { useFormSettings, useI18n } from "../../../contexts";
const FormSettingsFooter = ()=>{
    const { __ } = useI18n();
    const { isTcf, activeTab, onStartTcfVendorConfiguration } = useFormSettings();
    return /*#__PURE__*/ _jsx(Form.Item, {
        className: "rcb-antd-form-sticky-submit",
        colon: false,
        labelAlign: "left",
        label: /*#__PURE__*/ _jsx("a", {
            className: "button button-link",
            href: "#/settings/reset",
            children: __("Reset plugin and texts")
        }),
        style: {
            textAlign: "center"
        },
        children: /*#__PURE__*/ _jsxs(Space, {
            direction: "horizontal",
            children: [
                isTcf && activeTab === "tcf" && /*#__PURE__*/ _jsx("button", {
                    className: "button",
                    onClick: ()=>onStartTcfVendorConfiguration(),
                    style: {
                        marginRight: 10
                    },
                    children: __("Start vendor configuration")
                }),
                /*#__PURE__*/ _jsx("input", {
                    type: "submit",
                    className: "button button-primary",
                    value: __("Save settings")
                })
            ]
        })
    });
};
export { FormSettingsFooter };
